import React from 'react';
import {PropTypes} from 'prop-types';
import './CardWidget.scss';
import hrbLogo from '../../resources/images/hrb-logo.svg';
import ActionLink from "../link/ActionLink";
import CardWidgetSubmitButton from "./CardWidgetSubmitButton";
import WelcomeText from "../registration/welcome-text/WelcomeText";
import {Mobile} from "../responsive/responsive";

const CardWidget = (props) => (
    <div>
      <div className="hrb-card-widget-container">
        <Mobile>
          <WelcomeText
            title={props.mobileSideTitle}
            subTitle={props.mobileSideSubTitle}
          />
        </Mobile>
        <div className="hrb-card-widget-logo">
          <img src={hrbLogo} alt="hrb-header-logo"/>
        </div>
        <div className="hrb-card-widget-content">
          {props.getCardContent()}
        </div>
        <div className="hrb-card-widget-button-container">
          {props.submitButtonAction &&
          <div className="hrb-card-widget-submit-button">
            <CardWidgetSubmitButton text={props.submitButtonText} onClick={props.submitButtonAction}
                isDisabled={props.isSubmitDisabled}
                isLoading={props.isFormSubmitLoading}
                params={props.submitButtonParams}
            />
          </div>
          }
          {props.cancelButtonAction &&
          <div className="hrb-card-widget-cancel-button">
            <ActionLink text={props.cancelButtonText} onClick={props.cancelButtonAction} />
          </div>
          }
        </div>
      </div>
    </div>
);

CardWidget.propTypes = {
  getCardContent: PropTypes.func,
  submitButtonText: PropTypes.string,
  submitButtonAction: PropTypes.func,
  submitButtonParams: PropTypes.object,
  isSubmitDisabled: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  cancelButtonAction: PropTypes.func,
  isFormSubmitLoading: PropTypes.bool,
  mobileSideTitle: PropTypes.string,
  mobileSideSubTitle: PropTypes.string
};

export default CardWidget